import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { TherapyPlanDto } from '@therapist/shared/models/therapy-plan/therapy-plan.dto';
import { TherapyPlanListItemDto } from '@therapist/shared/models/therapy-plan/therapy-plan-list-item.dto';
import { TherapyPlanCreateDto } from '@therapist/shared/models/therapy-plan/therapy-plan-create.dto';
import { TherapyPlanStatusEnum } from '@therapist/shared/models/therapy-plan/therapy-plan-status.enum';
import { TherapyPlanUpdateDto } from '@therapist/shared/models/therapy-plan/therapy-plan-update.dto';
import { TherapyPlanProgressDto } from '@therapist/shared/models/therapy-plan/therapy-plan-progress.dto';
import { PreviousTherapyPlanDto } from '@therapist/shared/models/therapy-plan/previous-therapy-plan.dto';

@Injectable({providedIn: 'root'})
export class TherapyPlanAdministrationApiService {

  readonly #http = inject(HttpClient);

  private get endpoint() {
    return `${environment.basePath}/therapy-plan/administration`;
  }

  getAllByClientId(clientId: string): Observable<TherapyPlanListItemDto[]> {
    return this.#http.get<TherapyPlanListItemDto[]>(`${this.endpoint}/by-client/${clientId}`);
  }

  getById(id: string): Observable<TherapyPlanDto> {
    return this.#http.get<TherapyPlanDto>(`${this.endpoint}/${id}`);
  }

  save(therapyPlan: TherapyPlanCreateDto): Observable<TherapyPlanDto> {
    return this.#http.post<TherapyPlanDto>(`${this.endpoint}`, therapyPlan);
  }

  update(therapyPlan: TherapyPlanUpdateDto): Observable<TherapyPlanDto> {
    return this.#http.put<TherapyPlanDto>(`${this.endpoint}/${therapyPlan.id}`, therapyPlan);
  }

  updateTherapyPlanStatus(therapyPlanId: string, status: TherapyPlanStatusEnum): Observable<TherapyPlanDto> {
    return this.#http.put<TherapyPlanDto>(`${this.endpoint}/${therapyPlanId}/update-status`, {
      status: status
    });
  }

  getProgressByTherapyPlanId(id: string): Observable<TherapyPlanProgressDto> {
    return this.#http.get<TherapyPlanProgressDto>(`${this.endpoint}/${id}/progress`);
  }

  loadPreviousTherapyPlan(clientId: string): Observable<PreviousTherapyPlanDto> {
    return this.#http.get<PreviousTherapyPlanDto>(`${this.endpoint}/by-client/${clientId}/previous-plan`)
  }
}
